// The four themes: a palette each (palette.ts) plus the non-colour values the accessible version
// changes: boundary width, type scale, touch-target floor, shadows and motion. Tamagui publishes
// every key as a CSS variable (--borderW, --uiScale, ...) on the root, so components read them
// through var() and never branch on the interface version.
import { a11yDark, a11yLight, dark, light } from "./palette";

const standard = {
  borderW: "1px",
  ringW: "3",
  uiScale: "1",
  uiTarget: "48px",
  shSheet: "0 -12px 40px rgba(0, 0, 0, 0.45)",
  shFloat: "0 8px 24px rgba(0, 0, 0, 0.35)",
  durFast: "120ms",
  durBase: "220ms",
  durSlow: "420ms",
} as const;

const lightShadows = {
  shSheet: "0 -12px 40px rgba(42, 17, 25, 0.14)",
  shFloat: "0 8px 24px rgba(42, 17, 25, 0.12)",
} as const;

/** WCAG AAA, solid 2px boundaries, 17px base type, 56px targets, no decoration, no motion. */
const accessible = {
  borderW: "2px",
  ringW: "4",
  uiScale: "1.1333",
  uiTarget: "56px",
  shSheet: "none",
  shFloat: "none",
  durFast: "0.001ms",
  durBase: "0.001ms",
  durSlow: "0.001ms",
} as const;

export const themes = {
  dark: { ...dark, ...standard },
  light: { ...light, ...standard, ...lightShadows },
  a11yLight: { ...a11yLight, ...accessible },
  a11yDark: { ...a11yDark, ...accessible },
};
